import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageLanguageState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Language } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { CreateAndEditLanguageModal, LanguageTable } from "components/backoffice/language/index";


class ManageLanguage extends React.Component<UseFormReturn & WithSnackbarProps, ManageLanguageState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            languageCount: 0,
            languageList: [],
            data: null,
            isLoading: true,
            openEditLanguageModal: false,
            openCreateLanguageModal: false,
            editLanguage: null
        };
    }


    public componentDidMount() {
        this.getPaginatedLanguageWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(
            () => ({
                isLoading: true,
                pagination: pagination
            }),
            () => ContentProducerService.getLanguageListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getLanguageCallback, this.getLanguageErrorCallback)
        );

    }

    private getPaginatedLanguageWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getLanguageListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getLanguageCallback, this.getLanguageErrorCallback);
    }

    private deleteLanguage = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.languageList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        }

        ContentProducerService.deleteLanguage(id, this.getPaginatedLanguageWithStateParameters, this.deleteLanguageErrorCallback);
    }


    private getLanguageCallback = (data: DefaultTypedResponse<Language>): void => {

        this.setState(() => ({
            languageCount: data.size,
            languageList: data.list,
            isLoading: false,
        }));
    };

    private editLanguageCallback = (): void => {
        this.setState(() => ({ openEditLanguageModal: false }));
        this.getPaginatedLanguageWithStateParameters();
    };

    private createLanguageCallback = (): void => {
        this.setState(() => ({ openCreateLanguageModal: false }));
        this.getPaginatedLanguageWithStateParameters();
    };

    private deleteLanguageErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ml-error-delete-language",
            message: "Si è verificato un errore. La lingua non è stato eliminata"
        }), {
            variant: "error",
        });
    }

    private getLanguageErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ml-error-get-language",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editLanguageErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditLanguageModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ml-error-edit-language",
            message: "Si è verificato un errore. La lingua non è stato modificata"
        }), {
            variant: "error",
        });
    };

    private createLanguageErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateLanguageModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ml-error-create-language",
            message: "Si è verificato un errore. La lingua non è stata inserita"
        }), {
            variant: "error",
        });
    };


    private openEditLanguageModal = (language: Language): void => {
        this.setState(() => ({
            openEditLanguageModal: true,
            editLanguage: language
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditLanguageModal: false,
            editLanguage: null,
            openCreateLanguageModal: false,
        }));
    };

    private openCreateLanguageModal = (): void => {
        this.setState(() => ({
            openCreateLanguageModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="ml-text-title">Lingue</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateLanguageModal}
                        variant={"contained"}
                    >
                        <Trans id="ml-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <LanguageTable
                        pagination={this.state.pagination}
                        languages={this.state.languageList}
                        totalLanguageCount={this.state.languageCount}
                        deleteLanguage={this.deleteLanguage}
                        openEditLanguageTable={this.openEditLanguageModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditLanguageModal && <CreateAndEditLanguageModal
                    closeModal={this.closeModal}
                    editLanguageCallback={this.editLanguageCallback}
                    editLanguageErrorCallback={this.editLanguageErrorCallback}
                    language={this.state.editLanguage}
                />}
                {this.state.openCreateLanguageModal && <CreateAndEditLanguageModal
                    closeModal={this.closeModal}
                    createLanguageCallback={this.createLanguageCallback}
                    createLanguageErrorCallback={this.createLanguageErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageLanguage);